import { Box, Button, Drawer, MenuItem, TextField } from "@mui/material";
import SearchContainer from "components/SearchContainer";
import { useEffect, useState } from "react";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { dropDownType } from "../constants";
import DateRange from "views/dashboard/OrgDashboard/DateRange";
import { MultiSelectArrayField, MultiSelectField, SingleSelectField } from "./components";


const FilterEngine = ({ config, filters, setFilters, setPage }) => {


    const [open, setOpen] = useState(false);
    const [temp, setTemp] = useState(filters);


    const getEmptyValue = (field) => {
        if (
            field.multiple ||
            field.type === dropDownType.array
        ) {
            return [];
        }

        if (field.type === "DATE") {
            return { fromDate: null, toDate: null };
        }

        return null;
    };


    useEffect(() => {
        setTemp(filters);
    }, [filters]);

    const apply = () => {
        setFilters(temp);
        setOpen(false);
        setPage(0);
    };

    const clear = () => {
        const cleared = {};
        // Object.keys(filters).forEach(k => {
        //     cleared[k] = "";
        // });
        // Object.keys(filters).forEach((k) => {
        //     if (typeof filters[k] === "object" && filters[k] !== null) {
        //         cleared[k] = {};
        //         Object.keys(filters[k]).forEach(sub => {
        //             cleared[k][sub] = null;
        //         });
        //     } else {
        //         cleared[k] = "";
        //     }
        // });

        Object.keys(config).forEach((k) => {
            cleared[k] = getEmptyValue(config[k]);
        });
        setTemp(cleared);
        setFilters(cleared);
        setPage(0);
    };


    return (
        <>
            <Button
                variant="outlined"
                color="secondary"
                sx={{ marginLeft: "5px", marginRight: "5px" }}
                onClick={() => setOpen(true)}
                startIcon={<FilterAltOutlinedIcon />}
            >
                Filters
            </Button>

            <Drawer anchor="right" open={open} onClose={() => setOpen(false)}>
                <Box width={350} p={2}>

                    <Box sx={{
                        maxHeight: 600,
                        overflowY: "auto"
                    }}>
                        {Object.keys(config).map((key) => {
                            const field = config[key];

                            if (field.type === "search") {
                                return (
                                    <SearchContainer
                                        key={key}
                                        debounced
                                        placeHolder={field.placeholder}
                                        value={temp[key]}
                                        onChange={(val) => setTemp(prev => ({ ...prev, [key]: val, }))}
                                    />
                                );
                            }

                            if (field.type === "year") {
                                const years = field.options || [];

                                const sortedYears = [...years].sort(
                                    (a, b) => Number(b.split("-")[0]) - Number(a.split("-")[0])
                                );

                                const getLabel = field.getLabel
                                    ? field.getLabel
                                    : (year) => year;

                                const getValue = field.getValue
                                    ? field.getValue
                                    : (year) => year.split("-")[0];
                                return (
                                    <TextField
                                        select
                                        label={field.label}
                                        value={temp[key] ?? ""}
                                        onChange={(e) => setTemp(prev => ({ ...prev, [key]: e.target.value }))}
                                        size="small"
                                        fullWidth
                                        margin="normal"
                                    >
                                        <MenuItem value="">Select</MenuItem>

                                        {sortedYears.map((year, index) => (
                                            <MenuItem key={index} value={getValue(year)}>
                                                {getLabel(year)}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                )
                            }

                            if (field.type === dropDownType.object) {
                                const handleChange = (val) =>
                                    setTemp(prev => ({
                                        ...prev,
                                        [key]: val,
                                    }));
                                if (field.multiple) {
                                    return (
                                        <MultiSelectField
                                            key={key}
                                            field={field}
                                            value={temp[key]}
                                            onChange={handleChange}
                                        />
                                    );
                                }
                                return (
                                    // <TextField
                                    //     key={key}
                                    //     label={field.label}
                                    //     value={temp[key]}
                                    //     onChange={(e) => setTemp({ ...temp, [key]: e.target.value })}
                                    //     select
                                    //     fullWidth
                                    //     size="small"
                                    //     margin="normal"
                                    // >
                                    //     <MenuItem key="" value="">Select</MenuItem>
                                    //     {Object.keys(field.options).map((o) => (
                                    //         <MenuItem key={o} value={o}>{field.options[o]}</MenuItem>
                                    //     ))}
                                    // </TextField>
                                    <SingleSelectField
                                        key={key}
                                        field={field}
                                        value={temp[key]}
                                        onChange={handleChange}
                                    />
                                );
                            }

                            if (field.type === dropDownType.array) {
                                const opts = field.options || [];
                                const isDisabled = field.isLoading ?? false;

                                if (field.multiple) {
                                    return (
                                        <MultiSelectArrayField
                                            key={key}
                                            field={field}
                                            value={temp[key]}
                                            onChange={(val: any) => setTemp((prev: any) => ({ ...prev, [key]: val }))}
                                        />
                                    );
                                }

                                return (
                                    <TextField
                                        key={key}
                                        label={field.label}
                                        value={temp[key]}
                                        onChange={(e) => setTemp({ ...temp, [key]: e.target.value })}
                                        select
                                        fullWidth
                                        size="small"
                                        margin="normal"
                                        disabled={isDisabled}
                                        SelectProps={{
                                            MenuProps: { disableAutoFocusItem: isDisabled },
                                        }}
                                    >
                                        <MenuItem key="" value="">Select</MenuItem>
                                        {opts.map((item, index) => {
                                            const value = typeof item === "string" ? item : item.value;
                                            const label = typeof item === "string" ? item : item.label;

                                            return (
                                                <MenuItem key={index} value={value}>
                                                    {label}
                                                </MenuItem>
                                            );
                                        })}
                                    </TextField>
                                );
                            }

                            if (field.type === 'DATE') {
                                return (
                                    <Box key={key} mt={2} width='100%'>
                                        <DateRange
                                            dates={temp[key] || { fromDate: null, toDate: null }}
                                            setDates={(val) =>
                                                setTemp({
                                                    ...temp,
                                                    [key]: val,
                                                })
                                            }
                                            setPage={setPage}
                                        />
                                    </Box>
                                );
                            }

                        })}
                    </Box>

                    <Box mt={2} display="flex" >
                        <Button variant="outlined" onClick={clear} style={{ marginRight: 10 }}>Clear</Button>
                        <Button variant="contained" onClick={apply}>Apply</Button>
                    </Box>
                </Box>
            </Drawer>
        </>
    );
};

export default FilterEngine;
